var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"loading-fader"}},[_c('div',{staticClass:"c-spinner-container loading-fader",class:{ 'c-spinner--absolute' : _vm.isAbsolute }},[_c('div',{staticClass:"c-loading-spinner"})])])}
var staticRenderFns = []

export { render, staticRenderFns }